// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"18561518","500":"6bde17b0","2690":"60456b53","3624":"6bde17b0","6191":"9dca65ed","7350":"18561518"}[chunkId] + ".chunk.css";
};